import Vue from 'vue'
import VeeValidate from 'vee-validate'

const dictionary = {
	en: {
		messages: {
			min: (field, params) => ` ${field} must be at least ${params} characters.`,
			max: (field, params) => ` ${field} may not be greater than ${params} characters. `,
			between: (field, params) => `${field} must be between ${params[0]} and ${params[1]}`,
			required: (field, params) => `${field} is required`,
			numeric: (field, params) => `${field} must be a positive number.`,
			digits: (field, params) => `length must be ${params[0]}`,
			confirmed: (field, params) => `${field}s don't match`,
		},

		custom: {
			field: {
				required: 'field is required',
				digits: (field, params) => `length must be ${params[0]}`
			},
			term: {
				required: () => 'Please agree to terms and conditions to continue'
			}
		},
		attributes: {
			email: 'Email Address',
			username: 'Username',
			password: 'Password',
			confirmPassword: 'Confirm Password'
		}
	}
};

const dictionaryCountries = [{
		country: "23",
		message: "Invalid Account Format",
		pattern: "^([0-9]){6}-([0-9]){6,9}$"
	},
	{
		country: "172",
		message: "Invalid Account Format",
		pattern: "^([0-9]){2}-([0-9]){4}-([0-9]){7}-([0-9]){2,3}$"
	},
	{
		country: "250",
		message: "Invalid Account Format",
		pattern: "^[0-9]{6}-[0-9]{8,10}$"
	},
	{
		country: "251",
		message: "Invalid Account Format",
		pattern: "^([0-9]){9}-([0-9]){8,17}$"
	},
	{
		country: "56",
		message: "Invalid Account Format",
		pattern: "^(?=[0-9]{16,19}$)(62|60|95|94|40)[1-9][0-9]+$"
	},
	{
		country: "123",
		message: "Account number should be 7 digits.",
		pattern: "^[0-9]{7}$"
	}
];

const config = {
	dictionary: dictionary,
	errorBagName: 'errors', // change if property conflicts
	fieldsBagName: 'fields',
	delay: 0,
	locale: 'en',
	strict: true,
	classes: true,
	classNames: {
		touched: 'touched', // the control has been blurred
		untouched: 'untouched', // the control hasn't been blurred
		valid: 'valid', // model is valid
		invalid: 'invalid', // model is invalid
		pristine: 'pristine', // control has not been interacted with
		dirty: 'dirty' // control has been interacted with
	},
	events: 'input|blur',
	inject: true,
	validity: false,
	aria: true
}

VeeValidate.Validator.extend('age', {
	getMessage: field => `Age should be atleast 18 years.Please enter a valid Date of Birth.`,
	validate: value => {

		var today = new Date();

		var pcs = value.split('/');
		var year = pcs[2].split(' ');
		var birthDateNew = year[0] + '-' + pcs[1] + '-' + pcs[0];
		var birthDate = new Date(birthDateNew);
		var age = today.getFullYear() - birthDate.getFullYear();
		var m = today.getMonth() - birthDate.getMonth();

		if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
			age--;
		}
		if (age >= 18) {
			return true
		}
		return false;
	}

});

VeeValidate.Validator.extend('term_condition', {
	getMessage: field => `PPlease agree to terms and conditions to continue`,
	validate: value => {
		return false;
	}
});

VeeValidate.Validator.extend('verify_password', {
	getMessage: field => `Password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character`,
	validate: value => {
		var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
		return strongRegex.test(value);
	}
});

VeeValidate.Validator.extend('verify_mobile_email', {
	getMessage: field => `Invalid email or mobile number.`,
	validate: value => {
		var isValid = true;
		var mobileRegex = new RegExp("^(6?01)[0-9]{8,9}$");
		var ismobilevalid = mobileRegex.test(value);


		var isemailvalid = /^[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i.test(value);


		return ismobilevalid || isemailvalid;
	}
});
VeeValidate.Validator.extend('verify_mobile', {
	getMessage: field => `Invalid phone number.`,
	validate: value => {
		var isValid = true;
		var mobileRegex = new RegExp("^(1)[0-9]{8,9}$");
		var ismobilevalid = mobileRegex.test(value);


		var isemailvalid = /^[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i.test(value);


		return ismobilevalid || isemailvalid;
	}
});


VeeValidate.Validator.extend('BankAccount', {
	getMessage: (field, args, data) => {
		var message = dictionaryCountries.filter(p => p.country == args[0]);
		if (message == null)
			return "Invalid Account Format";
		else
			return message[0].message;

	},
	validate: (value, args) => {

		var selectedCountry = "";

		if (args == null)
			return true;

		if (args != null) {
			selectedCountry = args[0];
		}

		var regExpression = dictionaryCountries.filter(p => p.country == selectedCountry)[0];


		if (regExpression == null) return true;


		var strongRegex = new RegExp(regExpression.pattern);
		return strongRegex.test(value);
	}
});

VeeValidate.Validator.extend('BankAccount_Validation', {
	getMessage: (field, args, data) => {
		return args[1];

	},
	validate: (value, args) => {

		var selectedCountry = "";
		var regExpression = "";
		if (args == null)
			return true;

		if (args != null) {
			selectedCountry = args[0];
		}


		if (args[2] == "ALPHANUMERIC") {
			regExpression = `^[a-zA-Z0-9]{${args[3]},${args[4]}}$`;
		} else {
			regExpression = `^[0-9]{${args[3]},${args[4]}}$`;
		}


		var strongRegex = new RegExp(regExpression);
		return strongRegex.test(value);
	}
});

VeeValidate.Validator.extend('House_No', {
	getMessage: (field, args, data) => {
		debugger;
		var message = "Invalid House No.";
		if (args != null) {
			message = args[1];
		}

		return message;

	},
	validate: (value, args) => {
		debugger;
		var regexPattern = '';
		if (args == null)
			return true;

		if (args != null) {
			regexPattern = args[0].replace('%', ',');
		}

		if (regexPattern == null)
			return true;

		var strongRegex = new RegExp(regexPattern);
		return strongRegex.test(value);
	}
});

VeeValidate.Validator.extend('D2B_UPSTRING_DATA', {
	getMessage: (field, args, data) => {
		debugger;
		var message = "Only 5 of the following symbols - , . / \\ # ’ are allowed";

		return message;

	},
	validate: (value, args) => {
		debugger;

		if (args == null)
			return true;

		var regexPattern = "^(?!(?:.*[-,./\\\\#']){6})[a-zA-Z0-9-,./\\\\#' ]{1," + args[0] + "}$";
		var strongRegex = new RegExp(regexPattern);
		return strongRegex.test(value);
	}
});




VeeValidate.Validator.extend('validatePassword', {
	///getMessage: field => `The ${field} must be at least 8 characters long, and contain a number,one uppercase,one lower and one special characters.`,
	getMessage: field => `The ${field} must be at least 8 characters long, and contain a number,one uppercase and one lower characters.`,
	validate: value => {
		if (value != null && value.trim() != '') {
			//var REGEXP = /(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*\W)[a-zA-Z0-9]|(?=.*\W)[a-zA-Z0-9`!@#$%^&*()_=+\-\{\}\[\]|\\":;,./?]{8,25}/;
			var REGEXP = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\w~@#$%^&*+=`|{}:;!.?\"()\[\]-]{8,25}$/;
			return REGEXP.test(value) ? true : false;
		}
		return true;
	}
});

VeeValidate.Validator.extend('validatePasswordUpdated', {
	getMessage: field => '',
	validate: value => {
		if (value != null && value.trim() != '') {
			var REGEXP = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\w~@#$%^&*+=`|{}:;!.?\"()\[\]-]{8,25}$/;
			return REGEXP.test(value) ? true : false;
		}
		return true;
	}
});

VeeValidate.Validator.extend('validateMalaysianNumber', {
	getMessage: field => `Invalid malaysian mobile number`,
	validate: value => {
		if (value != null && value.trim() != '') {
			var REGEXP = /^601([0-9]){8,9}$/;
			return REGEXP.test(value) ? true : false;
		}
		return true;
	}
});

VeeValidate.Validator.extend('mobile', {
	getMessage: field => `Invalid mobile number`,
	validate: value => {
		if (value != null && value.trim() != '') {
			var REGEXP = /^\+?\d+$/;
			return REGEXP.test(value) ? true : false;
		}
		return true;
	}
});

VeeValidate.Validator.extend('mobile_aus', {
	getMessage: field => `Mobile Number must be at least 6 digits`,
	validate: value => {
		if (value != null && value.trim() != '') {
			var REGEXP = /^[0-9]{6,12}$/;
			return REGEXP.test(value) ? true : false;
		}
		return true;
	}
});

VeeValidate.Validator.extend('mobile_japan', {
	getMessage: field => `Mobile Number must be at least 6 digits`,
	validate: value => {
		if (value != null && value.trim() != '') {
			var REGEXP = /^[0-9]{6,10}$/;
			return REGEXP.test(value) ? true : false;
		}
		return true;
	}
});
VeeValidate.Validator.extend('mobile_hongkong', {
	getMessage: field => `Mobile Number must be at least 7 digits`,
	validate: value => {
		if (value != null && value.trim() != '') {
			var REGEXP = /^[0-9]{7,30}$/;
			return REGEXP.test(value) ? true : false;
		}
		return true;
	}
});

VeeValidate.Validator.extend('email_aus', {
	getMessage: field => `Invalid email`,
	validate: value => {
		if (value != null && value.trim() != '') {
			var REGEXP = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
			return REGEXP.test(value) ? true : false;
		}
		return true;
	}
});





VeeValidate.Validator.extend('USPostCode', {
	getMessage: field => `USA postcode should be in format XXXXX-XXXX`,
	validate: value => {
		if (value != null && value.trim() != '') {
			var REGEXP = /(^([0-9]){5}$)|(^([0-9]){5}-([0-9]){4}$)/;
			return REGEXP.test(value) ? true : false;
		}
		return true;
	}
});

VeeValidate.Validator.extend('JapanPostCode', {
	getMessage: field => `Invalid postcode`,
	validate: value => {
		if (value != null && value.trim() != '') {
			var REGEXP = /^[0-9\-]{3,20}$/;
			return REGEXP.test(value) ? true : false;
		}
		return true;
	}
});

VeeValidate.Validator.extend('AusPostCode', {
	getMessage: field => `Maximum 10 digits`,
	validate: value => {
		if (value != null && value.trim() != '') {
			var REGEXP = /^[0-9]{0,10}$/;
			return REGEXP.test(value) ? true : false;
		}
		return true;
	}
});


VeeValidate.Validator.extend('MyKad', {
	getMessage: field => `Invalid MyKad Number`,
	validate: value => {
		var myKadNumber = "";
		if (value) {
			let splitIdnumber = [];
			splitIdnumber = value.split("-");
			if (splitIdnumber.length == 3) {
				myKadNumber = splitIdnumber.join("");
			} else {
				myKadNumber = value;
			}
		}

		if (myKadNumber != null && myKadNumber.trim() != '') {
			var REGEXP = /([0-9][0-9])((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))([0-9][0-9])([0-9][0-9][0-9][0-9])/;
			return REGEXP.test(myKadNumber) ? true : false;
		}
		return true;
	}
});

VeeValidate.Validator.extend('Passport', {
	getMessage: field => `Invalid passport format`,
	validate: value => {
		if (value != null && value.trim() != '') {
			var REGEXP = /^(?!^0+$)[a-zA-Z0-9]{3,20}$/;
			return REGEXP.test(value) ? true : false;
		}
		return true;
	}
});



VeeValidate.Validator.extend('validateBonusLink', {
	getMessage: field => `Invalid bonus link`,
	validate: value => {

		if (value != null && value.trim() != '') {

			var REGEXP = /^601884([0-9]){10,13}$/;
			if (!REGEXP.test(value))
				return false;

			var number = value.split("").reverse();
			var sum = 0;
			for (var i = 0; i < number.length; i++) {
				if ((i + 1) % 2 == 0) {
					var multi = number[i] * 2;
					if (multi < 10)
						sum = sum + multi;
					else {
						var multiSum = multi.toString().split("").reduce((a, b) => {
							return parseInt(a) + parseInt(b)
						});
						sum = sum + multiSum;
					}
				} else
					sum = sum + parseInt(number[i]);
			}
			return sum % 10 == 0;
		}
		return true;
	}
});

VeeValidate.Validator.extend('passphrase_otp', {
	getMessage: field => `Invalid Key`,
	validate: value => {
		if (value != null && value.trim() != '') {
			var REGEXP = /^([0-9]){1}-([0-9]){1}-([0-9]){1}-([0-9]){1}-([0-9]){1}-([0-9]){1}$/;
			var strongRegex = new RegExp(REGEXP);
			return strongRegex.test(value) ? true : false;
		}
		return true;
	}

});

VeeValidate.Validator.extend('account_format', {
	getMessage: field => `Invalid Account format`,
	validate: value => {
   // Regular expression to validate the format XXX-XXX-XXXXXX or similar
   			const regex = /^\d{3}-\d{3,4}-\d{6,9}$/;
   			return regex.test(value);  // Returns true if valid, false if invalid
		}
});

//Validator.extend("WUNumber", {
//  validate: (value) => {
//	if (value != null && value.trim() != '') {
//	  return window.Vue.$http.get("/westernunion/kyclookup/value").then((response) => {
//		return {
//		  valid: response.data.valid,
//		  data: {
//			message: response.data.message
//		  }
//		};
//	  });
//	}
//	return true;
//  },
//  getMessage: field => `Invalid western union number`,
//});

Vue.use(VeeValidate, config)
